import { FormAddress, FormInputGroup, FormText } from 'components/form';
import parentStyles from '../OrganizationGeneral.module.scss';
import { Card, CardHeader, CardContent } from '@mui/material';

export const OrganizationInfo = () => {
    return (
        <div data-testid="OrganizationInfo">
            <Card className={parentStyles.card}>
                <CardHeader title="Info" />
                <CardContent>
                    <FormInputGroup>
                        <FormText field="name" label="Name" />
                    </FormInputGroup>
                    <FormInputGroup>
                        <FormText field="email" label="Email" />
                    </FormInputGroup>
                    <FormInputGroup>
                        <FormAddress field="address" />
                    </FormInputGroup>
                    <FormInputGroup>
                        <FormText field="website" label="Website" />
                        <FormText field="phone" label="Phone" />
                    </FormInputGroup>
                </CardContent>
            </Card>
        </div>
    );
};
